
export default {
    TOGGLE_ITEM_IN_CART(state, item) {
        var incluirTransporte = JSON.parse(localStorage.getItem("incluye_transporte"));
        var transporte = JSON.parse(localStorage.getItem("transporte"));

        if (incluirTransporte == 'S'){
            if (transporte.objectID == item.objectID && transporte.cod_clasificacion == item.cod_clasificacion) {
                const id_estudiante = item.id_estudiante;
                let datos = state.cartItems.filter(p => p.id_estudiante == id_estudiante);
                if (datos.length == 1) {
                    const index = state.cartItems.findIndex(i => i.objectID == item.objectID && i.student.id_usuario_estudiante == item.student.id_usuario_estudiante)
                    if (index !== -1) {
                        state.cartItems.splice(index, 1)
                    }
                    localStorage.setItem('carItems', JSON.stringify(_.orderBy(state.cartItems, ['nombre_completos'], ['desc'])));
                }
            } else{
                const index = state.cartItems.findIndex(i => i.objectID == item.objectID && i.student.id_usuario_estudiante == item.student.id_usuario_estudiante)
                if (index < 0) {
                    state.cartItems.push(item)
                } else {
                    state.cartItems.splice(index, 1)
                }
                localStorage.setItem('carItems', JSON.stringify(_.orderBy(state.cartItems,['nombre_completos'],['desc'])));
            }
        }
        else {
            const index = state.cartItems.findIndex(i => i.objectID == item.objectID && i.student.id_usuario_estudiante == item.student.id_usuario_estudiante)
            if (index < 0) {
                state.cartItems.push(item)
            } else {
                state.cartItems.splice(index, 1)
            }
            localStorage.setItem('carItems', JSON.stringify(_.orderBy(state.cartItems,['nombre_completos'],['desc'])));
        }

        // Separar esta parte en otra funcion
        const { objectID, cod_clasificacion } = transporte; // objectID , cod_clasificacion
        let datosCarrito = _.groupBy(state.cartItems, 'id_estudiante');

        _.forEach(datosCarrito, (estudiante) => {
            let contador = 0;
            let datosTransporte = null;
            _.forEach(estudiante, (p) => {
                contador++;
                if (p.cod_clasificacion == cod_clasificacion && p.objectID == objectID) {
                    datosTransporte = p;
                }
            })

            if (contador == 1 && datosTransporte) {
                const index = state.cartItems.findIndex(i => i.objectID == datosTransporte.objectID && i.student.id_usuario_estudiante == datosTransporte.student.id_usuario_estudiante)
                if (index !== -1) {
                    state.cartItems.splice(index, 1)
                }
                localStorage.setItem('carItems', JSON.stringify(_.orderBy(state.cartItems, ['nombre_completos'], ['desc'])));
            }
        })
    },
    ADD_ITEM_IN_CART(state, item) {
        var statusPreventa =  JSON.parse(localStorage.getItem('statusPreventa'));

        item.subtotal = _.round(item.subtotal,4);
        if((item.aplica_descuento == true || item.aplica_descuento == 'S' || item.aplica_descuento == "true" ) && statusPreventa){
            item.price_desc  = _.round(item.subtotal - ( item.subtotal * JSON.parse(localStorage.getItem('discount_post')) ),4);
            item.porcentaje_descuento  = JSON.parse(localStorage.getItem('discount_post'));
            item.valor_descuento =  _.round(item.subtotal * item.porcentaje_descuento,4);

            item.total = _.round(item.subtotal - item.valor_descuento ,4);
            // item.total = Math.round( (item.subtotal - item.valor_descuento) * 100 + Number.EPSILON ) / 100 ;
            // (item.subtotal - item.valor_descuento).toFixed(4);
        }else{
            item.price_desc           = 0;
            item.porcentaje_descuento = 0;
            item.valor_descuento      = 0;
            item.total                = _.round(item.quantity * item.price,4);
            // item.total                = Math.round( (item.quantity * item.price) * 100 + Number.EPSILON ) / 100 ;
            // (Math.round((item.quantity * item.price) * 100) /100 ).toFixed(4);
        }
        state.cartItems.push(item);
        state.cartItems = _.orderBy(state.cartItems,['nombre_completos','name'],['desc','desc']);
        localStorage.setItem('carItems', JSON.stringify(_.orderBy(state.cartItems,['nombre_completos','name'],['desc','desc'])));
    },
    UPDATE_ITEM_QUANTITY(state, payload) {
        var statusPreventa =  JSON.parse(localStorage.getItem('statusPreventa'));
            state.cartItems[payload.index].quantity = payload.quantity
            state.cartItems[payload.index].subtotal = _.round(state.cartItems[payload.index].quantity * state.cartItems[payload.index].price,4);
            if((state.cartItems[payload.index].aplica_descuento == 'S' 
                || state.cartItems[payload.index].aplica_descuento == true 
                || state.cartItems[payload.index].aplica_descuento === "true") && statusPreventa){
                state.cartItems[payload.index].price_desc  = _.round(state.cartItems[payload.index].subtotal - 
                    ( state.cartItems[payload.index].subtotal * JSON.parse(localStorage.getItem('discount_post'))),4);
                state.cartItems[payload.index].valor_descuento = _.round(_.round(state.cartItems[payload.index].subtotal,4) *
                 _.round(state.cartItems[payload.index].porcentaje_descuento,4));
                state.cartItems[payload.index].total = _.round(state.cartItems[payload.index].subtotal - state.cartItems[payload.index].valor_descuento,4);
                
                // state.cartItems[payload.index].total =
                // Math.round(  (state.cartItems[payload.index].subtotal - state.cartItems[payload.index].valor_descuento) * 100 + Number.EPSILON ) / 100 ;
                // (state.cartItems[payload.index].subtotal - state.cartItems[payload.index].valor_descuento).toFixed(4);

            }else{
                state.cartItems[payload.index].price_desc           = 0;
                state.cartItems[payload.index].porcentaje_descuento = 0;
                state.cartItems[payload.index].valor_descuento      = 0;
                state.cartItems[payload.index].total                = _.round(state.cartItems[payload.index].quantity * state.cartItems[payload.index].price,4);
                // Math.round( (state.cartItems[payload.index].quantity * state.cartItems[payload.index].price) * 100 + Number.EPSILON ) / 100 ;
                // (Math.round((state.cartItems[payload.index].quantity * state.cartItems[payload.index].price) * 100) /100 ).toFixed(4);
            }
            localStorage.setItem('carItems', JSON.stringify(_.orderBy(state.cartItems,['nombre_completos','name'],['desc','desc'])));
    },
    AGREGAR_PRODUCTO_SHOP(state, item) {
        var statusPreventa =  JSON.parse(localStorage.getItem('statusPreventa'));

        item.subtotal =_.round(item.subtotal,4);
        if((item.aplica_descuento == true || item.aplica_descuento == 'S' || item.aplica_descuento == "true" ) && statusPreventa){
            item.price_desc  = _.round(item.subtotal - ( item.subtotal * JSON.parse(localStorage.getItem('discount_post')) ) / 100 ,4);
            item.porcentaje_descuento  = JSON.parse(localStorage.getItem('discount_post'));
            item.valor_descuento =  _.round(item.subtotal * item.porcentaje_descuento,4);
            item.total = _.round(item.subtotal - item.valor_descuento,4);
            // item.total = Math.round( (item.subtotal - item.valor_descuento) * 100 + Number.EPSILON ) / 100 ;
            // (item.subtotal - item.valor_descuento).toFixed(4);
        }else{
            item.price_desc           = 0;
            item.porcentaje_descuento = 0;
            item.valor_descuento      = 0;
            item.total                = _.round(item.quantity * item.price, 4);
            // item.total                = Math.round( (item.quantity * item.price) * 100 + Number.EPSILON ) / 100 ;
            // (Math.round((item.quantity * item.price) * 100) /100 ).toFixed(4);
        }
        _.remove(state.cartItems, function(i) {
            return  i.objectID == item.objectID && i.student.id_usuario_estudiante == item.student.id_usuario_estudiante;
        });
        state.cartItems.push(item);
        state.cartItems = _.orderBy(state.cartItems,['nombre_completos','name'],['desc','desc']);
        localStorage.setItem('carItems', JSON.stringify(_.orderBy(state.cartItems,['nombre_completos','name'],['desc','desc'])));
    },
    ACTUALIZAR_PRODUCTO_SHOP(state, payload) {
        var statusPreventa =  JSON.parse(localStorage.getItem('statusPreventa'));
        // const producto = state.cartItems.find(i => i.objectID == item.objectID && i.student.id_usuario_estudiante == item.student.id_usuario_estudiante)
             payload.subtotal    = _.round(payload.quantity * payload.price,4);

            // payload.subtotal = (Math.round((payload.quantity * payload.price) * 100) / 100).toFixed(4);
            if((payload.aplica_descuento == 'S' 
                || payload.aplica_descuento == true 
                || payload.aplica_descuento === "true") && statusPreventa){
                payload.price_desc  = _.round(payload.subtotal - ( payload.subtotal * JSON.parse(localStorage.getItem('discount_post')) ) / 100 ,4);
                payload.valor_descuento = _.round(parseFloat(payload.subtotal) * parseFloat(payload.porcentaje_descuento),4);
                payload.total = _.round(payload.subtotal - payload.valor_descuento,4);                
                // payload.total =
                // Math.round(  (payload.subtotal - payload.valor_descuento) * 100 + Number.EPSILON ) / 100 ;
                // (state.cartItems[payload.index].subtotal - state.cartItems[payload.index].valor_descuento).toFixed(4);

            }else{
                payload.price_desc           = 0;
                payload.porcentaje_descuento = 0;
                payload.valor_descuento      = 0;
                payload.total    = _.round(payload.quantity * payload.price,4);

                // payload.total                = 
                // Math.round( (payload.quantity * payload.price) * 100 + Number.EPSILON ) / 100 ;
                // (Math.round((state.cartItems[payload.index].quantity * state.cartItems[payload.index].price) * 100) /100 ).toFixed(4);
            }
            _.remove(state.cartItems, function(i) {
                return  i.objectID == payload.objectID && i.student.id_usuario_estudiante == payload.student.id_usuario_estudiante;
            });
            state.cartItems.push(payload);
            state.cartItems = _.orderBy(state.cartItems,['nombre_completos','name'],['desc','desc']);
            localStorage.setItem('carItems', JSON.stringify(state.cartItems));
    },
    STORE_ITEMS(state){
        var productosStore = JSON.parse(localStorage.getItem('carItems'));
        if(!(_.isEmpty(productosStore)))
        state.cartItems = productosStore;
    },
    DELETE_ITEMS(state){
        localStorage.removeItem('carItems');
        state.cartItems = [];
    },
    AGREGAR_CLASIFICACION(state,item){
        localStorage.removeItem('clasificacion_seleccionada')
        localStorage.setItem('clasificacion_seleccionada', JSON.stringify(item));
        state.clasificacion_seleccionada    =   item;
    },
    UPDATE_CART_ALL(state, payload) {
        state.cartItems = payload;
        localStorage.setItem('carItems', payload);
    },
    ADD_ITEM_LOGIN(state, payload) {
        var productos = (_.orderBy(JSON.parse(payload,['nombre_completos','name'],['desc','desc'])));
        localStorage.setItem('carItems', JSON.stringify(productos));
        state.cartItems = _.clone(productos);
    },
}
